import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_BASE_URL = "https://bluewaterdubai.websiteseoonline.com";
const DEVELOPER_CITY = "Dubai";
const FALLBACK_LOGO = "/assets/img/brand/1.jpg";

function buildApiUrl(pathname) {
  const baseUrl = (process.env.REACT_APP_API_BASE_URL || API_BASE_URL).replace(/\/$/, "");
  return baseUrl + pathname;
}

function imageWithVariant(image, variant, fallback) {
  return image ? image + "/" + variant : fallback;
}

function slugify(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function developerSlug(developer) {
  const id = String(developer.id || "");
  const urlParts = String(developer.url || "")
    .split("/")
    .map((part) => part.trim())
    .filter(Boolean);
  const lastPart = urlParts[urlParts.length - 1];
  const slugFromUrl = lastPart === id ? urlParts[urlParts.length - 2] : urlParts.find((part) => !["developer", "developers", "develope"].includes(part));

  return slugify(slugFromUrl || developer.name) || "developer";
}

function developerLink(developer) {
  const id = developer.id ? encodeURIComponent(developer.id) : "";
  return id ? "/developers/" + developerSlug(developer) + "/" + id : "/developers";
}

function Developers() {
  const [developers, setDevelopers] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const controller = new AbortController();

    async function loadDevelopers() {
      setStatus("loading");

      try {
        const response = await fetch(buildApiUrl("/api/GetDevelopers.ashx"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ city: DEVELOPER_CITY }),
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error("Unable to load developers");
        }

        const payload = await response.json();
        const data = payload.result === 1 && Array.isArray(payload.data) ? payload.data : [];

        setDevelopers(data);
        setStatus("ready");
      } catch (err) {
        if (err.name !== "AbortError") {
          setDevelopers([]);
          setStatus("error");
        }
      }
    }

    loadDevelopers();

    return () => controller.abort();
  }, []);

  return (
    <>
      <div className="breadcumb-wrapper" style={{ backgroundImage: "url('/assets/img/wefwe.jpg')" }}>
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Long-term relationships with the developers that matter</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Developers</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="about-1-wrapper space overflow-hidden" id="about-sec">
        <div className="container">
          {status === "loading" && <div className="text-center">Loading developers...</div>}
          {status === "error" && <div className="text-center">Unable to load developers.</div>}
          {status === "ready" && developers.length === 0 && <div className="text-center">No developers found.</div>}
          {status === "ready" && developers.length > 0 && (
            <div className="row gy-40 gx-70 justify-content-center">
              {developers.map((developer) => (
                <div className="col-xl-2 col-lg-3 col-md-4 col-6" key={developer.id || developer.name}>
                  <div className="brand-box">
                    <Link to={developerLink(developer)} title={developer.name || "Developer"}>
                      <img
                        src={imageWithVariant(developer.ImagePath, "w=180,sharpen=1", FALLBACK_LOGO)}
                        alt={developer.name || "Developer logo"}
                      />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Developers;
